<template>
  <div
    class="map-container"
  >
    <div
      class="mapbox"
      @click="$emit('click')"
    >
      <v-snackbar
        class="infoBar"
        :value="infoBarText"
        :top="true"
        color="white"
        :timeout="0"
        style="top:-90px"
      >
        {{ infoBarText }}
        <v-icon
          class="mb-1 pointer"
          color="red"
          @click="infoBarText=null"
        >
          mdi-close
        </v-icon>
      </v-snackbar>
      <div
        v-if="!isLoaded"
        class="map noCustomerText"
      >
        <v-progress-circular
          indeterminate
          color="blue"
          width="2"
          size="38"
        />
      </div>
      <img
        v-if="markers.length && mapUrl"
        v-show="isLoaded"
        :src="mapUrl"
        alt="Map"
        class="map"
        @load="isLoaded=true"
      >
      <div
        v-else
        class="map noCustomerText"
      >
        リスト作成画面にて本日配送する顧客を選択してください。<br>
        既に顧客を選択している場合、その顧客には住所が登録されていない可能性があります。
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      isLoaded: false,
      infoBarText: null,
      mapUrl: null,
      markers: []
    }
  },
  computed: {
    ...mapGetters('list', ['selectedCustomers'])
  },
  mounted () {
    const urlContent = this.buildUrlContent()
    if (this.markers.length) this.mapUrl = this.buildMapUrl(urlContent)
  },
  methods: {
    setInfoBar () {
      this.infoBarText = '選択した顧客中上位１００件まで表示しています。'
    },
    /**
     * Gets location info from each selectedCustomers and stores marker info into this.markers, returning location info.
     * @return { { lon: object, lat: object }} object = { min, max, size, center }, all number.
     */
    buildUrlContent () {
      // longitude is (-180 ~ 180), latitude is (-90 ~ 90)
      let lon = { min: 181, max: -181 }
      let lat = { min: 91, max: -91 }

      for (let i = 0, len = this.selectedCustomers.length; i < len; i++) {
        // マーカーの上限は１００
        if (this.markers.length === 101) {
          this.setInfoBar()
          break
        }

        const { margin, location } = this.selectedCustomers[i]

        if (location !== undefined) {
          // lon & lat stored for customers have 7 decimal places.
          // Round it to 5 since it seems like Mapbox only look up to 5 decimal places.
          const longitude = Math.round(location.longitude * 100000) / 100000
          const latitude = Math.round(location.latitude * 100000) / 100000

          this.markers.push(`pin-s+${margin.style['background-color'].substr(1)}(${longitude},${latitude})`)

          lon = { min: Math.min(lon.min, longitude), max: Math.max(lon.max, longitude) }
          lat = { min: Math.min(lat.min, latitude), max: Math.max(lat.max, latitude) }
        }
      }

      if (!this.markers.length) return

      lon.center = (lon.max + lon.min) / 2
      lat.center = (lat.max + lat.min) / 2
      // container size is 4:3. Assign the size accordingly
      lon.size = Math.round(Math.abs(lon.max - lon.min) * 75)
      lat.size = Math.round(Math.abs(lat.max - lat.min) * 100)

      return { lon, lat }
    },
    buildMapUrl ({ lon, lat }) {
      const zoom = getZoom(Math.max(lon.size, lat.size))
      const bearing = 0 // 傾き２D
      const pitch = 0 // 傾き３D

      return `https://api.mapbox.com/styles/v1/zero-spec/ckccx53i52gsy1ildw1ophwnt/static/${this.markers.join(',')}/${lon.center},${lat.center},${zoom},${bearing},${pitch}/1200x900@2x?access_token=${process.env.MAPBOX_ACCESS_TOKEN}`
    }
  }
}

// Manually assigning zoom level considering the max distance of markers.
const getZoom = size => {
  if (size <= 1) return 14
  if (size <= 6) return 13
  if (size <= 9) return 12
  if (size <= 25) return 11
  if (size <= 47) return 10
  if (size <= 90) return 9
  if (size <= 180) return 8
  if (size <= 320) return 7
  return 6
}
</script>
<style lang="scss" scoped>
.map-container {
  position: fixed;
  width: 80%;
  max-width: 110vh;
  top: 53%;
  left: 53%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.mapbox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-top: 75%;
  transform: translateY(-50%);
}
.map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid var(--metal-grey-d);
  border-radius: 5px;

}
.noCustomerText{
  background:white;
  text-align:center;
  padding-top:35%;
  text-shadow:#00000021 5px 6px 11px;
  line-height: 2;
}
.infoBar{
  top: 0;
  color: black;
}
</style>
